export type AppLocale = "zh-CN" | "en" | "ja";

export const DEFAULT_LOCALE = "zh-CN" as const;
export const APP_LOCALES = [DEFAULT_LOCALE, "en", "ja"] as const satisfies readonly AppLocale[];
export const APP_LOCALE_LABELS: Record<AppLocale, string> = {
  "zh-CN": "简体中文",
  en: "English",
  ja: "日本語",
};

export function normalizeLocale(locale?: string | null): AppLocale {
  const normalized = String(locale ?? "")
    .trim()
    .toLowerCase();
  if (["zh", "zh-cn", "zh_hans", "zh-hans"].includes(normalized)) return "zh-CN";
  if (["en", "en-us", "en-gb"].includes(normalized)) return "en";
  if (["ja", "ja-jp"].includes(normalized)) return "ja";
  return DEFAULT_LOCALE;
}

let currentLocale: AppLocale = DEFAULT_LOCALE;
const localeListeners = new Set<(locale: AppLocale) => void>();

export function setLocale(locale: string) {
  const nextLocale = normalizeLocale(locale);
  if (nextLocale === currentLocale) return currentLocale;
  currentLocale = nextLocale;
  localeListeners.forEach((listener) => listener(nextLocale));
  return nextLocale;
}

export function getLocale() {
  return currentLocale;
}

export function subscribeLocaleChange(listener: (locale: AppLocale) => void) {
  localeListeners.add(listener);
  return () => localeListeners.delete(listener);
}
